"use client";

import { c as _c } from "react/compiler-runtime";
import { type RefObject, useEffect } from "react";
import { loadGsapWithScrollTrigger, shouldReduceMotion } from "@/lib/gsap";
export function useTechnologiesAnimation(sectionRef) {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== sectionRef) {
    t0 = () => {
      if (shouldReduceMotion()) {
        return;
      }
      let cleanup;
      let cancelled = false;
      const setupAnimation = async function setupAnimation() {
        const {
          gsap
        } = await loadGsapWithScrollTrigger();
        if (cancelled) {
          return;
        }
        const ctx = gsap.context(() => {
          const rows = gsap.utils.toArray(".technologies-carousel-row");
          gsap.set(rows, {
            opacity: 0,
            y: 28,
            filter: "blur(8px)"
          });
          gsap.to(rows, {
            opacity: 1,
            y: 0,
            filter: "blur(0px)",
            duration: 1.35,
            ease: "power3.out",
            stagger: 0.12,
            scrollTrigger: {
              trigger: sectionRef.current,
              start: "top 82%",
              toggleActions: "play reverse restart reverse"
            }
          });
        }, sectionRef);
        cleanup = () => ctx.revert();
      };
      setupAnimation();
      return () => {
        cancelled = true;
        cleanup?.();
      };
    };
    t1 = [sectionRef];
    $[0] = sectionRef;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
}